// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
import { getStorage, ref, listAll, getDownloadURL } from 'firebase/storage';
import { getFirestore } from "firebase/firestore";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8PCTo68Qcx8pMHBb5IOjiBjWKHfNS_J8",
  authDomain: "midvector-33.firebaseapp.com",
  projectId: "midvector-33",
  storageBucket: "midvector-33.appspot.com",
  messagingSenderId: "676108688398",
  appId: "1:676108688398:web:7021078c1844ac6d1cb05f",
  measurementId: "G-KKZ8H6EP5L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);
export { auth, storage, db, ref, listAll, getDownloadURL, analytics };